import { useMemo } from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { AvatarTable } from '@/features/Application/elements/tables'
import {
  LabeledValue,
  LabelText,
  ValueText,
  Wrapper,
  EmptyComponent
} from '@/features/Application/elements'

const PetInformation = ({ application, applicationLoading }) => {
  const { t } = useTranslation()
  const pets = application.user_pets ?? []
  const title = t('l.application.view.pets.label', 'Pets')
  const petsStyle = '76px 1fr'
  const data = useMemo(
    () =>
      pets.map(pet => ({
        avatar: pet.avatar,
        items: [
          {
            id: 'Type',
            cell: (
              <LabeledValue
                key="Type"
                label={<LabelText>{t('l.application.view.type.label', 'Type')}</LabelText>}
                value={<ValueText>{pet.type}</ValueText>}
                templateColumns={petsStyle}
              />
            )
          },
          {
            id: 'Breed',
            cell: (
              <LabeledValue
                key="Breed"
                label={<LabelText>{t('l.application.view.breed.label', 'Breed')}</LabelText>}
                value={<ValueText>{pet.breed}</ValueText>}
                templateColumns={petsStyle}
              />
            )
          },
          {
            id: 'Size',
            cell: (
              <LabeledValue
                key="Size"
                label={<LabelText>{t('l.application.view.size.label', 'Size')}</LabelText>}
                value={<ValueText>{t(`basic:b.pets.pet_sizes.${pet.size}.text`)}</ValueText>}
                templateColumns={petsStyle}
              />
            )
          },
          {
            id: 'Name',
            cell: (
              <LabeledValue
                key="Name"
                label={<LabelText>{t('l.application.view.name.label', 'Name')}</LabelText>}
                value={<ValueText>{pet.name}</ValueText>}
                templateColumns={petsStyle}
              />
            )
          },
          {
            id: 'Age',
            cell: (
              <LabeledValue
                key="Age"
                label={<LabelText>{t('l.application.view.date_of_birth.label', 'Age')}</LabelText>}
                value={
                  <ValueText>
                    {pet.birth_year ? moment().diff([pet.birth_year], 'years') : '-'}
                  </ValueText>
                }
                templateColumns={petsStyle}
              />
            )
          }
        ]
      })),
    [applicationLoading]
  )

  return (
    <Wrapper>
      <AvatarTable
        data={data}
        title={title}
        columns={1}
        subColumns={2}
        emptyComponent={
          <EmptyComponent isLoading={applicationLoading}>
            {t('l.application.view.no_pets.label', 'No pets included in this application.')}
          </EmptyComponent>
        }
      />
    </Wrapper>
  )
}

export default PetInformation
